import Cookies from 'js-cookie'
const state = {
    language: localStorage.getItem('language') || 'ru_RU',
    userSetlanguage: localStorage.getItem('userSetlanguage'),
    sysConfig: null,
    apkUrl: '',
    Pixel: Cookies.get('Pixel') || '',
    TaId: Cookies.get('TaId') || '',
    ClickId: Cookies.get('ClickId') || '',
    equipmentId: localStorage.getItem('equipmentId') || '',

    isShowDownAppNav: localStorage.getItem('isShowDownAppNav') || 1,
    isSaveVersionDesktop: 1,
    telegramUserId: '',
    isShowPlayGamePopup: false,
    betSportMsg: {
        brandId: null,
        gameInfoId: null,
        gameId: null,
        gamePlatformType: null,
        providerType: null
    },
    isShowSports: false,
    btObj: null
}

const mutations = {
    SET_LANGUAGE: (state, lang) => {
        state.language = lang
        localStorage.setItem('language', lang)
    },
    SET_USERSETLANGUAGE: (state, lang) => {
        state.userSetlanguage = lang
        localStorage.setItem('userSetlanguage', lang)
    },
    SET_SYSCONFIG: (state, config) => {
        state.sysConfig = config
    },
    SET_PIXEL: (state, info) => {
        const Key = 'Pixel'
        state.Pixel = info
        Cookies.set(Key, info)
    },
    SET_TAID: (state, info) => {
        const Key = 'TaId'
        state.TaId = info
        Cookies.set(Key, info)
    },
    SET_CLICKID: (state, info) => {
        const Key = 'ClickId'
        state.ClickId = info
        Cookies.set(Key, info)
    },
    SET_ISSHOWDOWNAPPNAV: (state, num) => {
        state.isShowDownAppNav = num
        localStorage.setItem('isShowDownAppNav', num)
    },
    SET_ISSAVEVERSIONDESKTOP: (state, num) => {
        state.isSaveVersionDesktop = num
    },
    SET_TELEGRAMUSERID: (state, ID) => {
        state.telegramUserId = ID
    },
    SET_APKURL: (state, url) => {
        state.apkUrl = url
    },
    SET_ISSHOWPLAYGAMEPOPUP: (state, data) => {
        state.isShowPlayGamePopup = data
    },
    SET_EQUIPMENTID: (state, ID) => {
        state.equipmentId = ID
        localStorage.setItem('equipmentId', ID)
    },
    SET_BETSPORTMSG(state, payload) {
        // payload是对象，只覆盖传入的字段，原有字段保留
        state.betSportMsg = { ...state.betSportMsg, ...payload }
    },
    SET_ISSHOWSPORTS: (state, data) => {
        state.isShowSports = data
    },
    SET_BTOBJ: (state, data) => {
        state.btObj = data
    }
}

const actions = {
    setLanguage({ commit }, lang) {
        commit('SET_LANGUAGE', lang)
    },
    setUserSetLanguage({ commit }, lang) {
        commit('SET_USERSETLANGUAGE', lang)
    },
    setSysConfig({ commit }, config) {
        commit('SET_SYSCONFIG', config)
    },
    setPixel({ commit }, data) {
        commit('SET_PIXEL', data)
    },
    setTaId({ commit }, data) {
        commit('SET_TAID', data)
    },
    setClickId({ commit }, data) {
        commit('SET_CLICKID', data)
    },
    setIsShowDownAppNav({ commit }, data) {
        commit('SET_ISSHOWDOWNAPPNAV', data)
    },
    setIsSaveVersionDesktop({ commit }, data) {
        commit('SET_ISSAVEVERSIONDESKTOP', data)
    },
    setTelegramUserId({ commit }, ID) {
        commit('SET_TELEGRAMUSERID', ID)
    },
    setApkUrl({ commit }, url) {
        commit('SET_APKURL', url)
    },
    setIsShowPlayGamePopup({ commit }, data) {
        commit('SET_ISSHOWPLAYGAMEPOPUP', data)
    },
    setEquipmentId({ commit }, ID) {
        commit('SET_EQUIPMENTID', ID)
    },
    setBetSportMsg({ commit }, payload) {
        commit('SET_BETSPORTMSG', payload)
    },
    setIsShowSport({ commit }, data) {
        commit('SET_ISSHOWSPORTS', data)
    },
    setBtObj({ commit }, data) {
        commit('SET_BTOBJ', data)
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}
